<div class="stepper" [class.collapsed]="collapsed()">

    <div class="collapse-btn-container">
        <button class="collapse-btn" (click)="toggle()">
            <i class="bi" [ngClass]="collapsed() ? 'bi-arrow-bar-right' : 'bi-arrow-bar-left'"></i>
        </button>
    </div>

    <div class="steps" #stepsContainer>

        <div class="line" [style.height.px]="lineHeightPx()"></div>
        <div class="line-progress" [style.height.px]="progressPx()"></div>

        @for (step of steps(); track step.id; let i = $index)
        {<div class="step" (click)="setActive(i)">
            
            <div class="circle" [class.complete]="getState(i) === 'complete'" [class.active]="getState(i) === 'active'">
                {{ i + 1 }}
            </div>

            <div class="content">

                @if (!collapsed()) {
                <div class="title">
                    {{ step.title }}
                </div>

                @if (step.pills?.length) {
                <div class="pill-container">
                    @for (pill of step.pills; track $index) {
                    <div class="pill-group">
                        <span class="pill-label">
                            {{ pill.label | abpLocalization }}
                        </span>

                        <zn-pill [label]="pill.value" variant="data" />
                    </div>
                    }
                </div>
                }
                }

            </div>
        </div>
        }
    </div>
</div>
